import React from 'react';

interface WidgetProgressProps {
  progress: number;
}

export const WidgetProgress: React.FC<WidgetProgressProps> = ({ progress }) => {
  return (
    <svg
      className="detailed-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="1.0088 2.0176 46 46"
      fill="none"
      style={{overflow: "visible", "--percent": progress} as React.CSSProperties}
    >
      <g filter="url(#filter0_d_86_198)">
              <circle cx="24.0088" cy="25.0176" r="23" fill="url(#paint0_radial_86_198)"></circle>
              <path
                d="M 5.777 36.411 A 21.5 21.5 0 1 1 42.241 36.411"
                fill="none"
                stroke="rgba(16, 50, 104, 1)"
                strokeWidth="3"
                strokeLinecap="butt"
              />
        <path
          d="M 5.777 36.411 A 21.5 21.5 0 1 1 42.241 36.411"
          fill="none"
          stroke="url(#paint1_linear_86_198)"
          strokeWidth="3"
          strokeLinecap="butt"
          pathLength="100"
          style={{
            strokeDasharray: "var(--percent), 100",
            transition: "stroke-dasharray 0.8s cubic-bezier(0.4, 0, 0.2, 1)"
          }}
        ></path>
      </g>
      <defs>
        <filter id="filter0_d_86_198" x="-4.85182e-05" y="-9.70364e-05" width="50.0354" height="50.0354" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="1.00884"/>
          <feGaussianBlur stdDeviation="1.00884"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_86_198"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_86_198" result="shape"/>
        </filter>
        <radialGradient id="paint0_radial_86_198" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(24.0088 25.0176) rotate(90) scale(23 20.1399)">
          <stop stopColor="rgba(22, 35, 89, 1)"/>
          <stop offset="1" stopColor="rgba(0, 7, 17, 1)"/>
        </radialGradient>
        <linearGradient id="paint1_linear_86_198" x1="15.5709" y1="12.8986" x2="41.2678" y2="38.5962" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgba(255, 205, 106, 1)"/>
          <stop offset="0.570735" stopColor="rgba(255, 221, 155, 1)"/>
          <stop offset="1" stopColor="rgba(201, 165, 93, 1)"/>
        </linearGradient>
      </defs>
    </svg>
  );
};
